import { Alert, Checkbox, Text } from "@theorgchartdev/storybook";
import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import {
  kConnectorDataKeys,
  kConnectorOptionalKeys,
  kKeyToLabelAndDefaultText,
  kPasswordMaskingKeys
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import * as StateLib from "@/Utils/StateLib";
import { appcstr } from "@coreapp/utils/appcstr";
import { appstr } from "@coreapp/utils/appstr";

const BuildInputs = (isBasicAuth, isAdminLogin) => {
  const requiredKeys = isAdminLogin
    ? kConnectorDataKeys["Sage 300 ZA"]
    : kConnectorDataKeys["Sage 300 ZA"].filter(k => k !== "site");
  const optionalKeys = kConnectorOptionalKeys["Sage 300 ZA"];
  const authKeys = isBasicAuth ? ["username", "password"] : [];

  const buildOption = (key, optional = false) => ({
    dataKey: key,
    label: appcstr(kKeyToLabelAndDefaultText[key][0]),
    placeholder: appcstr(kKeyToLabelAndDefaultText[key][1]),
    passwordMask: kPasswordMaskingKeys.includes(key.toLowerCase()),
    optional
  });

  return [
    ...requiredKeys.map(key => buildOption(key)),
    ...authKeys.map(key => buildOption(key)),
    ...optionalKeys.map(key => buildOption(key, true))
  ];
};

export const Sage300ZASetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const wsMgr = StateLib.GetWSMgr();
  const isAdminLogin = wsMgr?.fAdminLogin;
  const isBasicAuth = config?.isBasicAuth || false;

  return (
    <>
      {!isAdminLogin && (
        <Alert severity={"info"} withBorder showIcon style={{ margin: "16px 0" }}>
          <Text size={"small"} style={{ color: "inherit", lineHeight: 1.5 }}>
            {appstr("changeSage300za")}
            <a href="https://theorgchart.zendesk.com/">OrgChart Support</a>
          </Text>
        </Alert>
      )}
      <DataSourceSetupComposite
        config={config}
        onChange={onChange}
        index={index}
        chartConfig={chartConfig}
        showInputControls
        doInputLookup={false}
        inputOptions={BuildInputs(isBasicAuth, isAdminLogin)}
        showConfiguration={importType !== "import"}
        showLoadHeaders={importType !== "import"}
        importType={importType}
      >
        <Checkbox
          id={"toggle-basic-auth"}
          size={"medium"}
          label={appcstr("sageauthmethodtoggle")}
          checked={isBasicAuth}
          onChange={() => {
            onChange({ ...config, isBasicAuth: !isBasicAuth });
          }}
        />
      </DataSourceSetupComposite>
    </>
  );
};
